<template>
    <v-dialog v-model="value"
              content-class="flex-dialog white"
              fullscreen
              persistent
              transition="dialog-bottom-transition"
              :overlay="false"
              style="overflow: hidden;"
    >
        <v-toolbar dark class="primary ddd-animation-viewer--modal">
            <v-toolbar-title style="flex-grow: 1" class="ddd-animation-viewer--modal-title">{{ title }}</v-toolbar-title>
        </v-toolbar>
        <v-container class="dialog-content white" fluid style="overflow: hidden; padding: 0; margin: 0; position: relative;">
            <v-btn fab absolute style="width: 38px; height: 38px;background: #2b57ad; right: 10px; top: 12px;" id="animation--close" icon dark @click.native="closeAnimation">
                <v-icon>close</v-icon>
            </v-btn>
            <iframe v-if="value && url && !error"
                    id="animation_iframe"
                    :src="url"
                    name="animation_iframe"
                    frameborder="0"
                    scrolling="no"
                    style="overflow: hidden; margin: 0; padding: 0; border: none; height: 1px; max-width: 100%; max-height: 100%; min-height: 100%; width: 1px; min-width: 100%;"
            />
            <div v-else style="display: flex; align-items: center; height: Calc(100vh - 80px); width: 100%; text-align: center">
                <span style="font-style:italic; font-weight: 300; font-size: 18px; color: #ccc; display: block; width: 100%;" v-text="error ? error : $t('plan_simple.no_animation_to_display')" />
            </div>

            <div v-if="value && url && !error && !iframeLoaded" style="flex-direction: column; position: absolute; top: 0; left: 0; display: flex; justify-content: center; align-items: center; height: Calc(100vh - 80px); width: 100%; text-align: center">

                <div id="animation-loader-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="none" stroke="#2b57ad" stroke-width="32" d="M521.6 186.4S235.6 78 245.3 323.8c3.3 84.8 54.3 143.2 69.7 197 15.4 53.5 7.7 172.4 18 211.4 9.4 35.2 29 94 51 99.8 63 17 30.3-64.6 54.2-186.6 37.2-189 144-129.3 172.5-5.4 11.5 49.8-5 150.2 18.6 185 22.8 33.8 75 1 83.4-152.5 6-110.4 12-158.4 51.8-227.6 24.8-43 51-142.4 26.4-200-35.4-82-147-106.5-269.5-58.7z" stroke-linejoin="round"/></svg>
                </div>

                <span style="font-style:italic; font-weight: 300; font-size: 18px; color: #ccc; display: block; width: 100%;" v-text="'Loading...'" />
            </div>
        </v-container>
    </v-dialog>
</template>

<style>

#animation-loader-icon {
	display: inline-block;
	background: #2b57ad;
	display: inline-block;
	padding: 0.2vw;
	border-radius: 1vw;
	box-shadow: 0.4vw 0.4vw 0.4vw rgba(0,0,0,.1);
    width: 6vw;
	height: 6vw;
	min-width: 100px;
	min-height: 100px;
    margin-bottom: 10px;
}
#animation-loader-icon svg {
	width: 6vw;
	height: 6vw;
	min-width: 100px;
	min-height: 100px;
}

#animation-loader-icon svg path {
    fill: none;
    stroke: #fff;
    stroke-width: 55;
    stroke-linecap: round;
    stroke-dasharray: 2377 2573;
    stroke-dashoffset: 2358;
    animation-duration: 5s;
    animation-name: animation-loader-draw;
    animation-iteration-count: infinite;
}

@keyframes animation-loader-draw {
    0% {
        stroke-dashoffset: 2358;
    }
    50% {
        stroke-dashoffset: -50;
    }
    100% {
        stroke-dashoffset: -2620;
    }
}

.ddd-animation-viewer--modal {
    height: 52px !important;
}

@media (min-width: 700px) {
    .ddd-animation-viewer--modal,
    .ddd-animation-viewer--modal div {
        height: 52px !important;
    }

    .ddd-animation-viewer--modal-title {
        font-size: 18px;
    }

    #animation--close {
        width: 62px !important;
        height: 62px !important;
        right: 24px !important;
        top: 78px !important;
        border: 8px solid #c1cce0;
    }
}
</style>

<script>
import { commands, semaphore } from "@/utils/flutter/flutter2-semaphore";
import { invokeFlutterService } from '@/utils/flutter/flutter-service';

export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        animationData: {
            type: Object,
            default: null,
        },
        url: {
            type: String,
            default: "about:blank",
        },
        title: {
            type: String,
            default: null,
        },
    },
    data: function() {
        return {
            bottomNav: 0,
            contentHash: "",
            error: null,
            player: null,
            iframeLoaded: false,
        };
    },
    watch: {
        value: function() {
            if (!this.value) {
                try {
                    const el = document.getElementById("animation_iframe");
                    if (el) el.removeEventListener("playerStateChanged", this.handlePlayerStateChange, false);
                } catch(error) {
                    captureException(error);
                }
                this.url = "about:blank";
            } else {
                if (!this.title) this.title = this.$t("patient_view.plan_animation");
                this.error = null;
                this.iframeLoaded = false;
                this.$nextTick(() => {
                    this.getIframeHtml();
                });
            }
            this.$emit("input", this.value);
        },

        url: function() {
            if (this.url && this.url!=="about:blank") {
                this.$nextTick(() => {
                    document.getElementById("animation_iframe").onload = function() {
                        if (typeof document.getElementById("animation_iframe").addEventListener != "undefined") {
                            document.getElementById("animation_iframe").contentWindow.addEventListener("playerStateChanged", this.handlePlayerStateChange, false);
                        }
                    };
                });
            }
        },
    },

    methods: {

        closeAnimation() {
            invokeFlutterService("FlutterWakelockService", "unlock");
            if ('SemaphoreJavascriptChannel' in window) {
                semaphore({
                    name: commands.wakelock.command,
                    data: {
                        value: commands.wakelock.disableWakelock,
                    },
                })
            }
            this.value = false;
            window.Tracker.screenView("home");
            window.clearTimeout(this.adTimeout);
        },

        getIframeHtml: function() {
            if (this.animationData !== null && this.animationData.steps) {
                const html = "";
                request
                    .post("https://3dplayer.dev.planmaster.hu/player?key=4CQkCOyArbAVOZpVUv3sS1xhYi7Q5c3q")
                    .send(this.animationData)
                    .withCredentials(false)
                    .set("accept", "text/html")
                    .then((resp) => {
                        const element = document.getElementById("animation_iframe");
                        element.contentWindow.document.open();
                        element.contentWindow.document.write(resp.text);
                        element.contentWindow.document.close();
                        // this.iframeLoaded = true;
                        invokeFlutterService("FlutterWakelockService", "lock");
                        if ('SemaphoreJavascriptChannel' in window) {
                            semaphore({
                                name: commands.wakelock.command,
                                data: {
                                    value: commands.wakelock.enableWakelock,
                                },
                            })
                        }

                        window.Tracker.screenView("3d_animation");
                        if (typeof element.addEventListener != "undefined") {
                            element.contentWindow.addEventListener("playerStateChanged", this.handlePlayerStateChange, false);
                        } else {
                            this.iframeLoaded = true;
                        }
                    })
                    .catch((error) => {
                        captureException(error);
                        this.error = this.$t("core.error");
                        this.url = "about:blank";
                    });
            } else {
                this.url = "about:blank";
            }
        },

        handlePlayerStateChange(e) {
            const event = new CustomEvent("playerStateChanged", {
                detail: {
                    state: e.detail.state,
                },
                bubbles: true,
            });

            document.dispatchEvent(event);

            console.log(e.detail.state);
            if(!this.iframeLoaded) this.iframeLoaded = true;
        },
    },
};
</script>
